var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[(_vm.isOktaLoginEnabled)?_c('OktaFactorSettings',{attrs:{"canEditEmail":false}}):_c('MfaSettings',{staticClass:"mt-5 mb-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }